var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 198,
    height: 166,
    viewBox: "0 0 198 166",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3772 147.633L14.4583 151.234C14.0893 151.69 14.0893 152.341 14.4583 152.796L17.3772 156.398L13.78 153.476C13.3253 153.106 12.6744 153.106 12.2197 153.476L8.62256 156.398L11.5415 152.796C11.9104 152.341 11.9104 151.69 11.5415 151.234L8.62256 147.633L12.2197 150.555C12.6744 150.925 13.3253 150.925 13.78 150.555L17.3772 147.633Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26 152.016L13.6128 152.629L13 165.031L12.3872 152.629L0 152.016L12.3872 151.402L13 139L13.6128 151.402L26 152.016Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6808 5.30469L60.8867 7.51835C60.6599 7.79814 60.6599 8.19871 60.8867 8.4785L62.6808 10.6922L60.4698 8.89591C60.1904 8.66888 59.7902 8.66888 59.5108 8.89591L57.2998 10.6922L59.0939 8.4785C59.3207 8.19871 59.3207 7.79814 59.0939 7.51835L57.2998 5.30469L59.5108 7.10093C59.7902 7.32796 60.1904 7.32796 60.4698 7.10093L62.6808 5.30469Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9808 8L60.3671 8.37712L59.9904 16L59.6137 8.37712L52 8L59.6137 7.62287L59.9904 0L60.3671 7.62287L67.9808 8Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M117.751 141.879L114.875 139L112 141.879L114.875 144.758L117.751 141.879Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M136.751 7.87882L133.875 5L131 7.87883L133.875 10.7576L136.751 7.87882Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7509 49.8788L9.87549 47L7.00011 49.8788L9.87548 52.7576L12.7509 49.8788Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M179.751 141.879L176.875 139L174 141.879L176.875 144.758L179.751 141.879Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M189.377 38.1367L186.626 41.5311C186.279 41.9601 186.279 42.5743 186.626 43.0033L189.377 46.3977L185.987 43.6433C185.559 43.2952 184.945 43.2952 184.517 43.6433L181.126 46.3977L183.877 43.0033C184.225 42.5743 184.225 41.9601 183.877 41.5311L181.126 38.1367L184.517 40.891C184.945 41.2391 185.559 41.2391 185.987 40.891L189.377 38.1367Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M197.504 42.2669L185.83 42.8451L185.252 54.5337L184.675 42.8451L173 42.2669L184.675 41.6886L185.252 30L185.83 41.6886L197.504 42.2669Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStars);
export default __webpack_public_path__ + "static/media/stars.e89ead4791f1e880bc5b39cb63135120.svg";
export { ForwardRef as ReactComponent };